import { makeVar } from "@apollo/client"

/**
 * Pages the user has visited since the last assistant turn. Populated by the
 * provider on pathname changes and cleared after each `sendMessage` so the
 * model always sees a focused "what happened since last time" trail.
 */
export const outfitterAssistantHistoryVar = makeVar<AssistantVisitedPage[]>([])

export interface AssistantVisitedPage {
    screenName: string
    pathname: string
    entityIds?: { outfitterId: string }
    visitedAt: number
}
